// extracted by mini-css-extract-plugin
export default {"link":"SignupCodePage_link__9IboG","container":"SignupCodePage_container__X2XB-","copyToast":"SignupCodePage_copyToast__kn7L9"};